import React from 'react'

const SubTitle = ({ text }) => {
  return <h2 className='text-xl leading-tight font-bold'>{text}</h2>
}

export default SubTitle
